<template>
  <table class="table-hover reports-table invoices-report-table table">
    <InvoicesReportTableHeader :is-client="isClient" />

    <!-- eslint-disable vue/require-v-for-key -->
    <template v-for="section in tableData.sections">
      <tbody
        v-if="tableIsTeam"
        class="grouping-header"
      >
        <tr>
          <th>
            <template v-if="walker.main_type === 'date'">
              <template v-if="sumDateRanges">
                {{ $filters.formatDateRange(reportStartDate, reportEndDate) }}
              </template>
              <template v-else>
                {{ $filters.formatDate(section.main) }}
              </template>
            </template>
            <template v-else-if="walker.main_type === 'user'">
              <ReportTableAvatar
                :user-id="section.main_id"
                :url="section.rows[0].record.avatar_url"
              />
              <span class="user-name">{{ section.main }}</span>
            </template>
            <template v-else>
              {{ section.main }}
            </template>
          </th>
          <th
            v-for="col in colCount - 1"
            :key="col"
          ></th>
        </tr>
      </tbody>

      <tbody class="tbody">
        <tr v-for="row in section.rows">
          <td class="sticky-cell week-cell">
            <template v-if="row.sub_show_data">
              <template v-if="walker.sub_type === 'date'">
                <template v-if="sumDateRanges">
                  <span class="date-range">
                    {{ $filters.formatDateRange(reportStartDate, reportEndDate) }}
                  </span>
                </template>
                <template v-else>
                  <span>{{ formatDateLabel(row.record.sub) }}</span>
                </template>
              </template>
              <template v-else-if="walker.sub_type === 'user'">
                <ReportTableAvatar
                  :user-id="row.record.sub_id"
                  :url="row.record.avatar_url"
                />
                <span class="user-name">{{ row.record.sub }}</span>
              </template>
              <template v-else>
                {{ row.record.sub }}
              </template>
            </template>
          </td>
          <template v-if="sumDateRanges">
            <td class="sumdateranged">
              {{ $filters.currency(row.record.cached_grand_total, organization.currency) }}
            </td>
          </template>
          <template v-else>
            <td>
              <a :href="invoiceUrl(row.record)">{{ row.record.number }}</a>
            </td>
            <td>{{ row.record.report_status_name }}</td>
            <td>{{ $filters.currency(row.record.cached_grand_total, organization.currency) }}</td>
          </template>
          <td>{{ $filters.currency(row.record.cached_paid_amount, organization.currency) }}</td>
          <td>{{ $filters.currency(row.record.cached_balance, organization.currency) }}</td>
        </tr>
      </tbody>
      <tbody class="tfoot">
        <tr>
          <th>Total</th>
          <template v-if="!sumDateRanges">
            <th />
            <th />
          </template>
          <th>{{ $filters.currency(section.total.cached_grand_total, organization.currency) }}</th>
          <th>{{ $filters.currency(section.total.cached_paid_amount, organization.currency) }}</th>
          <th>{{ $filters.currency(section.total.cached_balance, organization.currency) }}</th>
        </tr>
      </tbody>
    </template>
    <!-- eslint-enable vue/require-v-for-key -->
  </table>
</template>

<script>
import { mapGetters } from 'vuex';
import InvoicesReportTableHeader from './InvoicesReportTableHeader.vue';

export default {
  name: 'InvoicesReportTable',
  components: { InvoicesReportTableHeader },
  props: {
    tableData: {
      type: Object,
      required: true,
    },
    isClient: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['walker', 'tableIsTeam', 'sumDateRanges', 'reportStartDate', 'reportEndDate', 'organization']),
    colCount() {
      if (this.sumDateRanges) {
        return 4;
      }

      return 6;
    },
  },
  methods: {
    formatDateLabel(value) {
      if (value === 'summed_date') {
        return TimeUtils.datetime_range(this.reportStartDate, this.reportEndDate);
      }

      return TimeUtils.format_date(TimeUtils.parse_internal_date(value));
    },
    invoiceUrl(record) {
      if (this.isClient) {
        return `/invoices/${record.id}`;
      }

      return `/invoices/I/${record.unique_hash_token}`;
    },
  },
};
</script>
